import {
  LOGIN_SU_USER,
  LOGIN_SU_SUCCESS,
  LOGOUT_SU_USER,
  LOGOUT_SU_USER_SUCCESS,
  API_SU_ERROR,
  SOCIAL_SU_LOGIN,
  } from "./constant"
  
  export const loginSuperUser = (user, history) => {
    return {
      type: LOGIN_SU_USER,
      payload: { user, history },
    }
  }
  
  export const loginSuperSuccess = user => {
    return {
      type: LOGIN_SU_SUCCESS,
      payload: user,
    }
  }
  
  export const logoutSuperUser = history => {
    return {
      type: LOGOUT_SU_USER,
      payload: { history },
    }
  }
  
  export const logoutSuperUserSuccess = () => {
    return {
      type: LOGOUT_SU_USER_SUCCESS,
      payload: {},
    }
  }
  
  export const apiSuperUserError = error => {
    return {
      type: API_SU_ERROR,
      payload: error,
    }
  }
  
  export const socialSuperUserLogin = (type, history) => {
    return {
      type: SOCIAL_SU_LOGIN,
      payload: { type, history },
    };
  };
  